import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { Order } from '~/components/Account/Logged/Orders/types'

import { useStyle } from '~/providers/StyleProvider'

import { ACCOUNT } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type OrderHeadProps = Pick<Order, 'reference' | 'date'> & {
  className?: string
  isActive?: boolean
}

function OrderHead({ className, isActive, reference, date }: OrderHeadProps) {
  const t = useTranslate()

  const labelStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskMedium,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })

  const actionStyle = useStyle({
    textStyling: GlobalTextStyling.Medium,
    color: isActive ? GlobalThemeColors.Gray : GlobalThemeColors.Black,
  })

  return (
    <div className={cx(className, css.OrderHead, labelStyle)}>
      <p>
        {t(ACCOUNT.ORDER)} {reference} - {date}
      </p>
      <div className={cx(css.cta, actionStyle)}>
        <span>{isActive ? t(ACCOUNT.CLOSE) : t(ACCOUNT.VIEW_ORDER)}</span>(
        {isActive ? `-` : `+`})
      </div>
    </div>
  )
}

OrderHead.defaultProps = {}

export default OrderHead
